import { produce } from 'immer'
import { UserState } from './UserState'
import { UserType } from './UserType'
import { GlobalType } from '../Global'
export const initialUserState: UserState = {
  id: '',
  displayname: null,
  email: 'hide',
  firstname: null,
  lastBackup: 0,
  lastModified: 0,
  lastname: null,
  cguVersionSigned: 0,
  cguVersionSignedDate: 0,
  createdAt: 0
}

export const userReducer = (state = initialUserState, action: Action) =>
  produce(state, draft => {
    switch (action.type) {
      case UserType.CREATE_USER: {
        return {
          ...initialUserState,
          ...action.payload.data
        }
      }
      case UserType.LOGOUT:
        return { ...initialUserState }
      case UserType.DEFINE_FIRSTNAME:
        draft.firstname = action.payload.firstname
        return
      case UserType.DEFINE_LASTNAME:
        draft.lastname = action.payload.lastname
        return

      case UserType.DEFINE_MAIL:
        draft.email = action.payload.email
        return
      case UserType.DEFINE_STRIPEID:
        draft.stripeCustomerId = action.payload.stripeCustomerId
        return

      case UserType.UPDATE_USER:
        return {
          ...state,
          ...action.payload.value
        }
      case UserType.DEFINE_VALUE_USER:
        draft = {
          ...state,
          ...action.payload.value
        }
        return
      case UserType.RESET_USER:
        return {
          ...initialUserState
        }
      case GlobalType.CLEAR_LOADED_DATA:
        return { ...initialUserState }

      case UserType.SIGN_CGU:
        draft.cguVersionSigned = action.payload.cguVersionSigned
        draft.cguVersionSignedDate = action.payload.cguVersionSignedDate
        return
    }
  })

type Action =
  | { type: GlobalType.CLEAR_LOADED_DATA }
  | { type: UserType.CREATE_USER; payload: { data: UserState } }
  | { type: UserType.UPDATE_USER; payload: { value: { [x: string]: unknown } } }
  | { type: UserType.LOGOUT }
  | { type: UserType.DEFINE_FIRSTNAME; payload: { firstname: string } }
  | { type: UserType.DEFINE_LASTNAME; payload: { lastname: string } }
  | { type: UserType.DEFINE_MAIL; payload: { email: string } }
  | { type: UserType.DEFINE_VALUE_USER; payload: { value: { [x: string]: unknown } } }
  | { type: UserType.SIGN_CGU; payload: { cguVersionSigned: number; cguVersionSignedDate: number } }
  | { type: UserType.RESET_USER }
  | { type: UserType.DEFINE_STRIPEID; payload: { stripeCustomerId: string } }
